export default "__VITE_ASSET__CuJNDafW__"